import { formatSelectionsArray, truncateSelectedValues } from './utils'
import { transmissionTypeData } from '@cinch-nx/data-search'

export const getFormattedGearbox = (
  transmissionTypeSelections: string[] = [],
) =>
  truncateSelectedValues(
    formatSelectionsArray(transmissionTypeSelections, transmissionTypeData),
  )
